import React from 'react';

import { useTestScenariosContext } from '../context';

import { Add as AddIcon } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

export default function CreateScenarioButton({ scenarioId }) {
  const {
    startAddScenarioProcess,
    editPermission,
    forceRestrictAllEdits,
    forceRestrictAllEditsReason,
  } = useTestScenariosContext();

  return (
    <Stack>
      <Tooltip title={forceRestrictAllEditsReason || ''} placement="top">
        <span>
          <IconButton
            title="create-scenario-btn"
            color="primary"
            size="small"
            disabled={!editPermission || forceRestrictAllEdits}
            onClick={() => startAddScenarioProcess(scenarioId)}
          >
            <AddIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
}
